import { useState } from 'react'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  IconButton,
  Button
} from '@mui/material'
import TextLabel from '../../../../../components/form/TextLabel/TextLabel'
import { countries } from '../../../../../utils/phone'
import { useNotification } from '../../../../../context/NotificationManager/NotificationManager'
import css from './DatosTelefono.module.css'

const PLANTILLA_MENSAJE_OPTIONS = [
  {
    name: 'Inicio',
    icon: <i className='material-icons'>person_search</i>,
    visible: () => true,
    message: ({ nombre }) =>
      `Hola ${nombre}! ¿qué tal? Le escribo de mundoestudiante en relación a un formulario web que rellenó solicitando información. Cuéntenos, ¿en qué podemos ayudarle?\n\n¡Un saludo!`
  },
  {
    name: 'Seguimiento',
    icon: <i className='material-icons'>update</i>,
    visible: () => true,
    message: () =>
      `Hola, ¿qué tal? Le escribo para conocer si seguían interesados en nuestros servicios.\n\nUn saludo, gracias.`
  },
  {
    name: 'Prueba',
    icon: <i className='material-icons'>event_note</i>,
    visible: ({ prueba }) => !!prueba,
    message: ({ fecha, hora, centro }) =>
      `Hola, ¿qué tal? Le escribo para confirmar la clase de prueba gratuita que tenemos programada para el día ${fecha} a las ${hora} en la academia de ${centro}.\n\n¡Un saludo, gracias!`
  },
  {
    name: 'Presupuesto',
    icon: <i className='material-icons'>thumb_up</i>,
    visible: () => true,
    message: () =>
      `Hola, ¿qué tal? Le escribo para conocer si ya habían tomado una decisión respecto a la propuesta que les dimos.\n\nUn saludo, gracias!`
  },
  {
    name: 'Cierre',
    icon: <i className='material-icons'>handshake</i>,
    visible: () => true,
    message: () =>
      `Hola! Para cualquier cosa, estamos a su disposición.\n\nUn saludo, gracias.`
  }
]

const getMensajeWhatsapp = ({ lead, mensaje, telefono }) => {
  const esPropio = telefono?.nombre?.toLowerCase() === 'propio alumno'
  if (mensaje.name === 'Inicio') {
    const nombre = esPropio
      ? lead.nombreAlumno
      : lead.nombreContacto || 'futuro alumno'
    return mensaje.message({ nombre })
  }
  if (mensaje.name === 'Prueba') {
    const prueba = lead.contactos?.findLast(
      contacto => contacto.estado === 'PRUEBA'
    )
    return mensaje.message({
      fecha: prueba?.proximoContacto,
      hora: prueba?.hora,
      centro: prueba?.centroPrueba
    })
  }
  return mensaje.message()
}

const DatosTelefono = ({ lead, onEdit }) => {
  const [isExpanded, setExpanded] = useState(true)
  const notification = useNotification()

  const handleChange = (_event, isExpanded) => {
    setExpanded(isExpanded)
  }

  const handleEdit = e => {
    e.stopPropagation()
    onEdit()
  }

  const telefonos = lead.telefonos || []

  const getCountryDisplay = prefix => {
    if (!prefix) return '-'
    const country = countries.find(c => c.callingCode === prefix)
    return country ? `${country.emoji} ${prefix}` : prefix
  }

  const showPrueba = lead.contactos?.some(
    contacto => contacto.estado === 'PRUEBA'
  )

  const handleSendWhatsAppMessage = (mensaje, telefono) => {
    if (!telefono?.telefono) {
      notification.error({
        title: 'Error enviando mensaje',
        content: 'Teléfono no válido'
      })
      return
    }
    const message = getMensajeWhatsapp({ lead, mensaje, telefono })
    const numeroWhatsApp = `${telefono.prefijoInternacional || '+34'}${telefono.telefono}`
    window.open(
      `https://wa.me/${numeroWhatsApp}?text=${encodeURIComponent(message)}`,
      '_blank'
    )
  }

  const handleCopyMessageToClipboard = (mensaje, telefono) => {
    const message = getMensajeWhatsapp({ lead, mensaje, telefono })
    navigator.clipboard
      .writeText(message)
      .then(() => {
        notification.success({
          title: 'Copiado',
          content: `Mensaje de ${mensaje.name} copiado al portapapeles`
        })
      })
      .catch(() => {
        notification.error({
          title: 'Error',
          content: 'No se pudo copiar el mensaje'
        })
      })
  }

  return (
    <Accordion expanded={isExpanded} onChange={handleChange}>
      <AccordionSummary
        expandIcon={<i className='material-icons'>expand_more</i>}
      >
        <div className={css.label}>
          <Typography className={css.title} variant='h2'>
            Datos de teléfono
          </Typography>
          {isExpanded && (
            <IconButton
              className={css.button}
              size='small'
              color='secondary'
              onClick={handleEdit}
            >
              <i className='material-icons'>edit</i>
            </IconButton>
          )}
        </div>
      </AccordionSummary>
      <AccordionDetails className={css.details}>
        {telefonos.length === 0 ? (
          <div className={css.emptyState}>
            <Typography variant='body2' color='textSecondary'>
              No hay teléfonos registrados
            </Typography>
          </div>
        ) : (
          <div className={css.telefonosContainer}>
            {telefonos.map((telefono, index) => (
              <div key={index} className={css.telefonoRow}>
                <TextLabel
                  className={css.field}
                  name={`contacto-${index}`}
                  label='Contacto'
                  value={telefono.nombre || '-'}
                />
                <div className={css.phoneFields}>
                  <TextLabel
                    className={css.countryField}
                    name={`flag-${index}`}
                    label='Prefijo'
                    value={getCountryDisplay(telefono.prefijoInternacional)}
                  />
                  <TextLabel
                    className={css.field}
                    name={`telefono-${index}`}
                    label='Teléfono'
                    value={telefono.telefono}
                  />
                </div>
                <div className={css.whatsappButtons}>
                  {PLANTILLA_MENSAJE_OPTIONS.filter(option =>
                    option.visible({ prueba: showPrueba })
                  ).map(mensaje => (
                    <div key={mensaje.name} className={css.actionIconWrapper}>
                      <Button
                        className={css.whatsappButton}
                        variant='contained'
                        color='primary'
                        title={mensaje.name}
                        onClick={() =>
                          handleSendWhatsAppMessage(mensaje, telefono)
                        }
                      >
                        {mensaje.icon}
                      </Button>
                      <IconButton
                        className={css.copyIconFloating}
                        size='small'
                        onClick={e => {
                          e.stopPropagation()
                          handleCopyMessageToClipboard(mensaje, telefono)
                        }}
                      >
                        <i className='material-icons'>content_copy</i>
                      </IconButton>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </AccordionDetails>
    </Accordion>
  )
}

export default DatosTelefono
